import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { EventService } from "../../../services";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

function EventCategory(props) {
  const [showModal, setShow] = useState(false);
  const [error, setError] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  // const [description, setDescription] = useState("");
  const [isactive, setIsActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  // const [showPreviousButton, setShowPreviousButton] = useState(false);
  // const [showNextButton, setShowNextButton] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);

  const handleAdd = async (e) => {
    setId("");
    setName("");
    //setDescription("");
    setIsActive(false);
    handleShow();
    setError("");
  };

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await EventService.getEventCategoryList();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleName = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val?.trim() === "") {
      setError("Name is required");
    } else {
      setError("");
    }
    setName(val);
  };

  // const handleDescription = (e) => {
  //   e.preventDefault();
  //   const val = e.target.value;
  //   // if (val.trim() === "") {
  //   //   setError("Description is required");
  //   // } else {
  //   //   setError("");
  //   // }
  //   // setDescription(val);
  // };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;

    if (name?.trim() === "") {
      setError("Name is required");
      valid = false;
      return;
    } else {
      setError("");
    }
    // if (description.trim() === "") {
    //   setError("Answer is required");
    //   valid = false;
    //   return;
    // } else {
    //   setError("");
    // }
    if (!valid) {
      setError("Please fill all fields");
      return;
    } else {
      setError("");
      try {
        props.application.setLoading(true);
        if (id === "") {
          const data = {
            name: name?.trim(),
            // description: description.trim(),
            isactive: isactive,
          };
          const res = await EventService.addEventCategory(data);
          if (res?.isSuccess) {
         
            props.application.setLoading(false);
            toast.success(res?.message);
          } else {
            toast.error("Something went wrong");
            props.application.setLoading(false);
          }
        } else {
          const data = {
            name: name.trim(),
            isactive: isactive,
            id: id,
            logo: null,
            order: 1,
          };
          const res = await EventService.updateEventCategory(data);
          if (res?.isSuccess) {
            props.application.setLoading(false);
            toast.success(res?.message);
          } else {
            toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
            props.application.setLoading(false);
          }
        }
        handleClose();
        setId("");
        getData();
      } catch (err) {
        props.application.setLoading(false);
        const message = handleConsoleError(err);
        toast.error(err?.message || message);
        setId("");
      }
    }
  };

  const handleEdit = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await EventService.getEventCategoryById(id);

      if (res?.isSuccess) {
        setName(res?.data?.name);
        setIsActive(res?.data?.isActive);
        setId(id);
        handleShow();
        props.application.setLoading(false);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      const message=handleConsoleError(error)
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  const rowsPerPage = 50; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    // if (selected === 0) {
    //   setShowPreviousButton(false);
    // } else {
    //   setShowPreviousButton(true);
    // }

    // const pageCount = Math.ceil(filteredData.length / rowsPerPage);

    // if (filteredData.length === 0) {
    //   setShowNextButton(false);
    // } else if (selected === pageCount - 1) {
    //   setShowNextButton(false);
    // } else {
    //   setShowNextButton(true);
    // }
  };

  const onDragEnd = async (result) => {
    try {
      const { destination, source } = result;

      if (!destination) {
        return;
      }

      if (destination.index === source.index) {
        return;
      }
      props.application.setLoading(true);
      const reorderedItems = reorder(
        filteredData,
        source.index,
        destination.index
      );
      setFilteredData(reorderedItems);

      // reorderedItems.map(((s, i) = { ...s, order: i }));
      const orderList = reorderedItems.map((item, index) => ({
        ...item,
        order: index + 1,
      }));

      await EventService.eventsCategoryOrder(orderList);
      setTimeout(() => {
        props.application.setLoading(false);
      }, 500);
    } catch (error) {
      const message=handleConsoleError(error)
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };
  return (
    <React.Fragment>
      {/* <TableOrder columns={columns} initialData={initialData} /> */}
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            {/* <li className="breadcrumb-item">Content Management</li>*/}
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Event Category
            </li>
          </ol>
        </nav>
      </div>
      <div className="verifier-buttton">
        <Button onClick={handleAdd}>Add Event Category</Button>{" "}
      </div>
      <Modal show={showModal} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>
            {id === "" ? "Add" : "Update"} Event Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="searchformfld">
              <label>
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Name"
                value={name}
                maxLength="50"
                onChange={handleName}
                required
              />

              <div className="custom-check">
                <label>Status </label>
                <input
                  type="checkbox"
                  checked={isactive} // Controlled by state
                  onChange={handleIsActive} // Handle change event
                />
              </div>
            </div>
            {error && <span className="text-danger">{error}</span>}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            type="submit"
            variant="primary custom-button-colour"
            onClick={handleSubmit}
          >
            {id === "" ? "Save" : "Update"}
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="table-responsive">
        <div>
          <h2>Event Category</h2>
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <Table
                ref={provided.innerRef}
                {...provided.droppableProps}
                // style={{ listStyleType: "none", padding: 0 }}
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Created On</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((item, index) => (
                    <Draggable
                      key={item?.id}
                      draggableId={item?.id}
                      index={index}
                    >
                      {(provided) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            userSelect: "none",
                            padding: "10px",
                            margin: "5px 0",
                            width: "100%",
                            // background: "lightgray",
                            borderRadius: "5px",
                            ...provided.draggableProps.style,
                          }}
                        >
                          {/* <tr key={idx}> */}
                          <td>{calculateSNo(index)}</td>
                          <td>{item?.name}</td>

                          <td> {formatDateENGB(item?.createdOn)}</td>
                          <td className="delete-create">
                            {item?.isActive === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>
                            </div>
                          </td>
                          {/* </tr> */}
                        </tr>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </tbody>
              </Table>
            )}
          </Droppable>
        </DragDropContext>
        {/* <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Created On</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item.name}</td>

                      <td>{formatDateENGB(item.createdOn)}</td>
                      <td className="delete-create">
                        {item.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item.id);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table> */}
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? (
          <p>No results found!</p>
        ) : (
          renderPagination()
        )}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(EventCategory);
